import { useState } from 'react'
import { Provider } from 'react-redux'
import { persistor, store } from "@stores";
import { PersistGate } from "redux-persist/integration/react";
import AppRoutes from "@routes/AppRoutes";
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from "react-hot-toast";

function App() {

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  )
}

export default App
